import { render, staticRenderFns } from "./preCourse.vue?vue&type=template&id=3189855f&scoped=true&"
import script from "./preCourse.vue?vue&type=script&lang=js&"
export * from "./preCourse.vue?vue&type=script&lang=js&"
import style0 from "./preCourse.vue?vue&type=style&index=0&id=3189855f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3189855f",
  null
  
)

export default component.exports